/** Auth endpoint calls — signup, signin, token refresh, signout, password management. */
import type { AuthResponse, Language } from '@olimhub/shared'
import { apiClient } from '../client'

export interface SignupInput {
  username: string
  email: string
  password: string
  displayName?: string
  feedLanguages?: Language[]
}

export interface SigninInput {
  email: string
  password: string
}

export const authApi = {
  signup: (body: SignupInput) =>
    apiClient.post<AuthResponse>('/auth/signup', body).then((r) => r.data),

  signin: (body: SigninInput) =>
    apiClient.post<AuthResponse>('/auth/signin', body).then((r) => r.data),

  refresh: () =>
    apiClient.post<AuthResponse>('/auth/refresh').then((r) => r.data),

  signout: () => apiClient.post('/auth/signout').then((r) => r.data),

  // Errors are swallowed intentionally to avoid revealing whether an email
  // exists — except a 429, which isn't account-specific and is worth
  // surfacing so the user knows *why* nothing arrived.
  forgotPassword: (email: string) =>
    apiClient.post('/auth/password-recovery', { email }).then((r) => r.data).catch((err) => {
      if (err?.response?.status === 429) throw err
      return undefined
    }),

  resetPassword: (token: string, newPassword: string) =>
    apiClient.post('/auth/password-reset', { token, newPassword }).then((r) => r.data),

  passwordChange: (body: { currentPassword: string; newPassword: string }) =>
    apiClient.put('/auth/password-change', body).then((r) => r.data),

  deleteAccount: (body: { password: string }) =>
    apiClient.delete('/auth/account', { data: body }).then((r) => r.data),
}
